import { api } from "@/lib/api";

// Fire-and-forget event tracking for the Master Admin Marketing tab.
// Never blocks the UI and never throws on failure.
export function trackEvent(type, value = "") {
  api.post("/analytics/track", { type, value: String(value) }).catch(() => {});
}
